import { styled } from "styled-components";
import theme from "../../styles/theme";

import { useGetStatusCount } from "../../interfaces/dashboard";
import React, { useEffect, useState } from "react";
import NowNext from "./NowNext";

import ListAltIcon from '@mui/icons-material/ListAlt';
import VideocamIcon from '@mui/icons-material/Videocam';
import LaptopWindowsIcon from '@mui/icons-material/LaptopWindows';
import VerifiedIcon from '@mui/icons-material/Verified';

// const MainWrap = styled.div`
//     height: 100%;
//     width: 100%;
//     display: grid;
//     grid-template-columns: repeat(auto-fit, minmax(20%,auto));
//     gap: 1rem;
// `;

const Card = styled.div`
    // border: 1px solid red;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e8e7de;
    height: 100%;
    max-height: 6rem;
`;

const CardMarkArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.3rem;
`;

const CardMark = styled.div`
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`
const sampleData = {
    I: 1,
    S: 13,
    E: 0,
}

const StatusCards = () => {
    const {data} = useGetStatusCount();
    const [countList,setCountList] = useState({I:0,S:0,E:0});

    useEffect(()=>{
        if(data){
            setCountList(data[0]);
        }
    },[data])

    return (
        <React.Fragment>
            <Card>
                <CardMarkArea style={{width: '30%'}}>
                    <CardMark style={{background: theme.color.secondary.blueA}} ><ListAltIcon style={{fontSize:'2rem',color:'#ffffff'}}/></CardMark>
                    <span style={{fontSize:'1.2rem',fontWeight:600}}>예정<br/>현황</span>
                </CardMarkArea>
                <NowNext color={'#e8e7de'} />
            </Card>
            <Card>
                <CardMarkArea>
                    <CardMark style={{background:theme.color.setting2}} ><VideocamIcon style={{fontSize:'2rem',color:'#ffffff'}}/></CardMark>
                    <span style={{fontSize:'1.5rem',fontWeight:600}}>설치/촬영</span>
                </CardMarkArea>
                <div style={{width:'3rem'}} />
                <span style={{fontSize:'2.5rem',fontWeight:600}}>{countList.I}</span>
            </Card>
            <Card>
                <CardMarkArea>
                    <CardMark style={{background:theme.color.coding2}} ><LaptopWindowsIcon style={{fontSize:'2rem',color:'#ffffff'}}/></CardMark>
                    <span style={{fontSize:'1.5rem',fontWeight:600}}>코딩</span>
                </CardMarkArea>
                <div style={{width:'3rem'}} />
                <span style={{fontSize:'2.5rem',fontWeight:600}}>{countList.S}</span>
            </Card>
            <Card>
                <CardMarkArea>
                    <CardMark style={{background:theme.color.complete2}} ><VerifiedIcon style={{fontSize:'2rem',color:'#ffffff'}}/></CardMark>
                    <span style={{fontSize:'1.5rem',fontWeight:600}}>완료/납품</span>
                </CardMarkArea>
                <div style={{width:'3rem'}} />
                <span style={{fontSize:'2.5rem',fontWeight:600}}>{countList.E}</span>
            </Card>
        </React.Fragment>
    )
}

export default StatusCards;
